import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { BreadcumWrapper, Title } from "./bc.elm";

export default function Breadcum({ menu, title, hrefParent, options, ...props }) {
    return (
        <BreadcumWrapper>
            <Wrapper>
                <div className="breadcum">
                    {options && options.length > 0 ? (
                        options.map((item, index) => {
                            return (
                                <span className="breadcum-item" key={index}>
                                    <Link to={item.value} style={{ color: "#797979" }}>
                                        &nbsp;{item.label}&nbsp;
                                    </Link>
                                    {index != options.length - 1 && (
                                        <div className="icon">
                                            <GoRight />
                                        </div>
                                    )}
                                </span>
                            );
                        })
                    ) : (
                        <React.Fragment>
                            <span className="breadcum-item">
                                <Link to={"/"} style={{ color: "#797979" }}>
                                    &nbsp;Trang chủ&nbsp;
                                </Link>
                                {title && (
                                    <div className="icon">
                                        <GoRight />
                                    </div>
                                )}
                            </span>
                            <span className="breadcum-item">
                                <Link to={hrefParent ? hrefParent : "#"} style={{ color: "#797979" }}>
                                    &nbsp;{title}&nbsp;
                                </Link>
                            </span>
                        </React.Fragment>
                    )}
                </div>
                <Title>{title ? <h4>{title}</h4> : ""}</Title>
            </Wrapper>
        </BreadcumWrapper>
    );
}

const GoRight = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10" fill="none">
            <path d="M1 1L5 5L1 9" stroke="#A5A5A5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
};

const Wrapper = styled.div`
    .icon {
        display: flex;
        margin: 0 5px;
    }

    span.breadcum-item {
        display: flex;
        align-items: center;
    }
`;
